<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme-continue">
      <div class="info">
        <div class="tips">
          <h3>{{$t('crm_contract_change_continue.ztsmzyxtjdsbckyxz') }}</h3>
          <p>{{$t('crm_contract_change_continue.1yzfzbzhyqkx') }}</p>
          <p>{{$t('crm_contract_change_continue.2sbdqrq30tn') }}</p>
          <p>{{$t('crm_contract_change_continue.3sbzbhtwxz') }}</p>
        </div>
        <div class="item-title">
          {{ $t('crm_contract_change_continue.xzxzsb') }}
        </div>
        <div class="table-bd">
          <!--  @input="selectionChange($event, 'selectRows')" -->
          <custom-table
            ref="tb1"
            type="checkbox"
            v-model="selectRows"
            :data="dataList"
            :column="tableColumn"
            @sort="sortChange"
            @filter="filterChange"
            :expand="true"
            :default-expand-all="true"
            :slots="['continueTime', 'action']"
            selectableKey="selectableKey"
            @selection-change="handleSelectionChange"
          >
           <!-- <el-table-column type="selection" :selectable="checkboxSelect" width="40" slot="prepose"></el-table-column> -->
            <template slot="expand" slot-scope="scope">
              <div class="tab-wrap">
                <el-form label-position="top" class="wrap-form">
                  <el-row :gutter="15" class="wrap-form-row">
                    <template>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_continue.zu_jin_yue')" prop="unitPrice">
                          {{ scope.row.currencyUnit }}
                          {{ scope.row.unitPrice }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item :label="$t('crm_contract_change_continue.shfjfy')" prop="additionalFee">
                          <el-input v-model="scope.row.additionalFee" style="width: 66%">
                            <template slot="prepend">{{ scope.row.currencyUnit }}</template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item :label="$t('crm_contract_change_continue.fu_kuan_qi_shu')">
                          {{ computedNum(scope.row, 'periodNum') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_change_continue.sqfcfa')">
                          {{ scope.row.sharingClass}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item :label="$t('crm_contract_change_continue.shou_qi_zu_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ computedNum(scope.row, 'firstRent') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item :label="$t('crm_contract_change_continue.lei_ji_zu_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ computedNum(scope.row, 'totalRent') }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item  :label="$t('crm_contract_change_continue.ya_jin_tai')">
                          <el-input v-model="scope.row.depositFee" placeholder style="width: 66%">
                            <template slot="prepend">
                              {{ scope.row.currencyUnit }}
                            </template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </template>
                  </el-row>
                </el-form>
                <ul class="rent-amount">
                  <li>
                    <p class="titel">{{$t('crm_contract_change_continue.sqljzj')}}</p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ computedNum(scope.row, 'firstRentTotal') }}
                    </p>
                  </li>
                  <li>
                    <p class="titel">{{$t('crm_contract_change_continue.lei_ji_ya_jin')}}</p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ computedNum(scope.row, 'depositFeeTotal') }}
                    </p>
                  </li>
                  <li>
                    <p class="titel">{{$t('crm_contract_change_continue.shou_qi_xu_zhi_fu')}}</p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ computedNum(scope.row, 'firstPay') }}
                    </p>
                  </li>
                </ul>
              </div>
            </template>
            <template slot="continueTime" slot-scope="scope">
              <el-input disabled type="number" v-model="scope.row.rentalTerm" style="width: 98%"></el-input>
            </template>
            <template slot="action" slot-scope="scope">
              <el-button type="text" @click="addLeaseItem(scope.row)">{{$t('crm_contract_change_continue.ghzlfa')}}</el-button>
            </template>
          </custom-table>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <!-- 租赁合同续租 -->
      <template v-if="backType==='continueOrder'">
        <el-button type="primary" @click="confim">{{$t('crm_contract_change_continue.xybtxljhc')}}</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="confim">{{$t('crm_contract_change_continue.xybqrhtxx')}}</el-button>
      </template>
    </div>
    <!-- 选择方案 -->
    <contractManagement-addLease-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="addLeaseList"></contractManagement-addLease-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractManagementAddLeaseDialog from './contractManagement_addLease_dialog.vue';

export default {
  components: { contractManagementAddLeaseDialog },
  props: {
    backType: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number],
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
  },
  data() {
    return {
      tableCode: 'dateEndContinue',
      dataList: [],
      selectRows: [],
      form: {
        bizClass: 21,
        bizId: '',
        deviceGoodsList: [],
        lastOrderId: '',
        operateFlag: '',
      },
      selectDevice: [],
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
    };
  },
  mounted() {
    this.form.lastOrderId = this.getJump('lastOrderId');
    this.getTableColumn();
    this.getDeviceList();
  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    // checkboxSelect(row) {
    //   return !!row.isAllowRenewal;
    //   // return true;
    // },
    // 表格选中变更
    selectionChange: function (val, name) {
      // 如果topic controlMode设置设备是1那就是单选
      this[name] = val;
    },
    // 租赁计算
    computedNum: function (row, name) {
      // 累计押金
      if (name === 'depositFeeTotal') {
        row.depositFeeTotal = (+row.depositFee * +row.bookingNum).toFixed(2);
        return row.depositFeeTotal;
      }
      // 首期租金(合计)
      if (name === 'firstRentTotal') {
        row.firstRentTotal = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm) * +row.bookingNum).toFixed(2);
        return row.firstRentTotal;
      }
      // 首期需支付
      if (name === 'firstPay') {
        row.firstPay = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm) * +row.bookingNum + +row.depositFee * +row.bookingNum).toFixed(2);
        return row.firstPay;
      }
      // 租赁期数
      if (name === 'periodNum') {
        row.periodNum = Math.ceil(+row.rentalTerm / (+row.paymentPeriod || +row.rentalTerm || 0));
        return row.periodNum;
      }
      // 首期租金/台
      if (name === 'firstRent') {
        row.firstRent = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm)).toFixed(2);
        return row.firstRent;
      }
      // 累计租金/台
      if (name === 'totalRent') {
        row.totalRent = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * +row.rentalTerm).toFixed(2);
        return row.totalRent;
      }
      return '';
    },
    // 合同设备列表
    getDeviceList: function () {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.lastOrderId,
        showDeviceType: 0,
        showCurrentPeriod: 1,
        contractChangeType: 26,
        bizState: '22,45' // 租赁中 已到期
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.bookingNum = 1;
          item.oldRentalTerm = item.rentalTerm;
          item.selectableKey = !item.isAllowRenewal;
          // 初始化标记
          this.$set(item, 'hasChangedScheme', false);
        });
        this.dataList = list;
        this.getChangeDetail();
      });
    },
    // 处理表格选中变化
    handleSelectionChange: function (val) {
      this.selectRows = val;

      if (this.contractId) {
        return;
      }
      // 如果存在选中的行，且其中有未更换过方案的行，则自动触发第一个这样的行
      if (val && val.length > 0) {
        // 找到第一个选中但未标记 hasChangedScheme 的行
        const rowToProcess = val.find(item => !item.hasChangedScheme);

        if (rowToProcess) {
          // 为了防止多次快速点击导致多个弹窗，可以加一个简单的锁或者只处理第一个
          this.$nextTick(() => {
            this.addLeaseItem(rowToProcess);
          });
        }
      }
    },
    // 合同设备列表详情
    getChangeDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.contractId,
        showDeviceType: 0,
        bizState: '10,21' // 待发货 待起租
        // showCurrentPeriod: 1,
      }).then((res) => {
        // 上次选中的
        this.selectDevice = res.data;
        this.dataList.forEach((item) => {
          const row = this.selectDevice.find(t => t.lastOrderDeviceId === item.orderDeviceId);
          if (row) {
            this.$setFormatData(item, row);
            this.deviceGoodsList = row;
            this.$refs.tb1.$emit('toggleRowSelection', item, true);
          }
        });
      });
    },


    confim: function () {
      if (!this.selectRows.length) {
        this.$message.error(this.$t('crm_contract_change_continue.qxzxzsb'));
        return;
      }

      // 只能续租同一个售后公司的设备
      let flag = false;
      for (let i = 1; i < this.selectRows.length; i++) {
        if (this.selectRows[i].afterServiceId !== this.selectRows[i - 1].afterServiceId) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$message.error(this.$t('crm_contract_change_continue.znxztygshgsdsb'));
        return;
      }
      const hasLastIsRbt = this.selectRows.find(t => `${t.lastIsRbt}` === '1');

      if (hasLastIsRbt) {
        const tips = this.$t('crm_contract_change_continue.jshwodsbqxhzlfazjxxz', [hasLastIsRbt.bodyNum]);
        this.$message.error(tips);
        return;
      }

      const hasEmpty = this.selectRows.find(t => !`${t.rentalTerm}` || !`${t.additionalFee}` || !`${t.depositFee}`);
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_change_continue.qjsjtxwz'));
        return;
      }
      const unitPriceFree = this.selectRows.find(
        t => t.unitPrice === 0
      );
      if (unitPriceFree) {
        this.$message.error(this.$t('crm_contract_change_continue.qbjzlfazjbnxy0'));

      }
      this.form.operateFlag = this.operateFlag;

      // this.selectRows[0].lastOrderDeviceId = this.selectRows[0].orderDeviceId;
      if (!this.contractId) {
        this.addContractContinue();
      } else {
        this.updateContractContinue();
      }
    },
    // 期末续租新增
    addContractContinue: function () {
      this.selectRows.forEach((i) => {
        i.lastOrderDeviceId = i.orderDeviceId;
      });
      this.form.deviceGoodsList = this.selectRows;
      this.$postJSON(apis.ContinueRentAdd, this.form).then((res) => {
        this.$emit('syncContractId', res.data, 21);
        this.$emit('success');
      });
    },
    // 期末续租保存
    updateContractContinue: function () {
      this.form.bizId = this.contractId;
      this.selectRows.forEach((item) => {
        const oldItem = this.selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
        if (oldItem) {
          item.lastOrderDeviceId = oldItem.lastOrderDeviceId;
        } else {
          item.lastOrderDeviceId = item.orderDeviceId;
        }

      });
      this.form.deviceGoodsList = this.selectRows;
      this.$postJSON(apis.ContinueRentUpdate, this.form).then((res) => {
        this.$emit('syncContractId', res.data, 21);
        this.$emit('success');
      });
    },
    // 新增方案弹窗
    addLeaseItem: function (row) {
      this.dialogVisible = true;
      this.dialogModel.type = 'date_end_continue';
      this.dialogModel.row = row;
      this.dialogModel.title = this.$t('crm_contract_change_continue.xzzlfa');
    },
    // 选择方案弹窗回调
    addLeaseList: function (list, rentalTerm) {
      this.dialogModel.row.rentalTerm = rentalTerm;
      this.$setFormatData(this.dialogModel.row, list[0], 'paymentPeriod,depositFee,paymentNode,unitPrice,goodsSkuId');
      // 设置不为1  就不是rbt的租赁方案了
      this.dialogModel.row.lastIsRbt = 0;
      // 标记为已处理
      this.$set(this.dialogModel.row, 'hasChangedScheme', true);

      // 显式关闭弹窗，因为子组件可能只发射了 success 事件但没有内部关闭逻辑，或者依赖父组件控制
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.changeDesc .el-form-item__content {
  width: 100%;
}

.content-scheme-continue {
  padding: 14px 24px 0;

  .tips{
    background: rgba(249,200,81,0.15);
    padding: 10px;
     margin-bottom: 20px;
    color:#495057;
    font-size: 14px;
    p{
      font-size: 12px;
    }
  }

  table {
    border-collapse: collapse;
  }
  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*='cell'] {
    padding: 0;
  }
  .tab-wrap {
    // padding: 0 24px;
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;
      }
    }
    .rent-amount {
      background: #ffffff;
      padding: 0 8px;
      display: flex;
      li {
        width: 100px;
        margin: 20px 16px 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        height: 50px;
        .title {
          height: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
          line-height: 16px;
        }
        .amount {
          margin-top: 6px;
          height: 28px;
          font-size: 12px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }
}
</style>
